import React from 'react';
import { Tooltip } from 'antd';

const textTruncate = ({ text, truncateTextLength = 20, enableTooltip }) => {
  if (!text) return '';
  if (text.length > truncateTextLength && enableTooltip) {
    return (
      <Tooltip title={text}>
        {text.slice(0, Math.max(0, truncateTextLength))}...
      </Tooltip>
    );
  }
  if (text.length > truncateTextLength) {
    return `${text.slice(0, Math.max(0, truncateTextLength))}...`;
  }
  return text;
};
export { textTruncate };